import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CourseCard from "./CourseCard";
import dataScientist from '../../assets/images/data-scientist.png'
import uiuxImg from '../../assets/images/ui-ux.png'
import projectMngr from '../../assets/images/project_manager.png'
import cyberImg from '../../assets/images/cyber-security.png'
import digitalImag from '../../assets/images/digital-marketing.png'
import "./careers.css";

import { Fade, Slide } from "react-awesome-reveal";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel'; // Import Owl Carousel JS (Important for react-owl-carousel v2.3.1 and below)
import AOS from 'aos';
import 'aos/dist/aos.css';

const careersList = [
  {
    id: 1,
    title: "Software Developer",
    description: "Join our team as a Software Developer to build innovative solutions and advance your technical expertise.",
    location: "San Francisco, CA",
    imageUrl: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
    banner_img_url: "https://images.unsplash.com/photo-1533750349088-cd871a92f312",
    applyNowUrl: "https://forms.gle/apply-software-developer",
    technicalSkills: ["JavaScript", "React", "Node.js", "MongoDB", "Git"],
    responsibilities: [
      "Develop and maintain web applications.",
      "Collaborate with cross-functional teams.",
      "Write clean, scalable code.",
      "Debug and troubleshoot software issues.",
      "Participate in code reviews."
    ],
    workExperience: "2+ years of professional experience in software development."
  },
  {
    id: 2,
    title: "Data Scientist",
    description: "Work with cutting-edge data technologies to uncover insights and drive impactful decisions.",
    location: "New York, NY",
    imageUrl: dataScientist,
    banner_img_url: "https://images.unsplash.com/photo-1523475496153-3d6ccf48d7c3",
    applyNowUrl: "https://forms.gle/apply-data-scientist",
    technicalSkills: ["Python", "R", "SQL", "Machine Learning", "Data Visualization"],
    responsibilities: [
      "Analyze large datasets to identify trends.",
      "Develop predictive models and algorithms.",
      "Collaborate with stakeholders to define project goals.",
      "Present findings in clear, actionable formats.",
      "Ensure data accuracy and security."
    ],
    workExperience: "3+ years of experience in data analysis and modeling."
  },
  {
    id: 3,
    title: "UI/UX Designer",
    description: "Design intuitive and visually appealing user experiences for our digital products.",
    location: "Austin, TX",
    imageUrl: uiuxImg,
    banner_img_url: "https://images.unsplash.com/photo-1506765515384-028b60a970df",
    applyNowUrl: "https://forms.gle/apply-ui-ux-designer",
    technicalSkills: ["Adobe XD", "Sketch", "Figma", "HTML/CSS", "User Research"],
    responsibilities: [
      "Design user interfaces for web and mobile applications.",
      "Create wireframes, prototypes, and mockups.",
      "Conduct user research and usability testing.",
      "Collaborate with developers to ensure design feasibility.",
      "Stay updated with design trends and best practices."
    ],
    workExperience: "2+ years of experience in UI/UX design."
  },
  {
    id: 4,
    title: "Project Manager",
    description: "Lead cross-functional teams to deliver high-quality projects on time and within budget.",
    location: "Remote",
    imageUrl: projectMngr,
    banner_img_url: "https://images.unsplash.com/photo-1521133573892-e6ea1f0f35ec",
    applyNowUrl: "https://forms.gle/apply-project-manager",
    technicalSkills: ["Agile Methodologies", "Project Planning", "JIRA", "Risk Management", "Communication"],
    responsibilities: [
      "Plan and oversee projects from initiation to completion.",
      "Define project scope, goals, and deliverables.",
      "Manage project timelines and budgets.",
      "Coordinate with team members and stakeholders.",
      "Identify and mitigate project risks."
    ],
    workExperience: "5+ years of experience in project management."
  },
  {
    id: 5,
    title: "Cybersecurity Analyst",
    description: "Protect our systems and data by implementing advanced security measures and protocols.",
    location: "Seattle, WA",
    imageUrl: cyberImg,
    banner_img_url: "https://images.unsplash.com/photo-1508739773434-c26b3d09e071",
    applyNowUrl: "https://forms.gle/apply-cybersecurity-analyst",
    technicalSkills: ["Network Security", "Incident Response", "Penetration Testing", "SIEM Tools", "Cryptography"],
    responsibilities: [
      "Monitor systems for security breaches.",
      "Implement security protocols and firewalls.",
      "Conduct vulnerability assessments and penetration tests.",
      "Develop and maintain incident response plans.",
      "Train employees on cybersecurity best practices."
    ],
    workExperience: "3+ years of experience in cybersecurity."
  },
  {
    id: 6,
    title: "Digital Marketing Specialist",
    description: "Drive our digital campaigns and help expand our online presence with innovative strategies.",
    location: "Chicago, IL",
    imageUrl: digitalImag,
    banner_img_url: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
    applyNowUrl: "https://forms.gle/apply-digital-marketing",
    technicalSkills: ["SEO", "Google Analytics", "Content Marketing", "Social Media Management", "PPC Advertising"],
    responsibilities: [
      "Plan and execute digital marketing campaigns.",
      "Monitor and optimize campaign performance.",
      "Conduct keyword research for SEO.",
      "Create engaging content for various platforms.",
      "Analyze market trends and audience behavior."
    ],
    workExperience: "2+ years of experience in digital marketing."
  }

];






const options = {
  loop: true,
  margin: 10,
  nav: false, 
  dots: false,
  autoplay: true,
  smartSpeed: 1500,
  autoplayTimeout: 3500,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    800: { items: 4 },
    1150: { items: 6 },
  },
};


function Careers() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);
  // useEffect(() => {
  //   AOS.init();
  // }, []);


  return (
    <div className="">
           <div className="floating-icons">
        <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
          <button

            className="sm_icon"
          >
            <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
          </button>
        </a>
        <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
          </button>
        </a>
        <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
          </button>
        </a>
        <a className="icon" href="https://wa.me/+918688964015" target="_blank">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
          </button>
        </a>
      </div>
      <div className="careers_bg_bnnaer mt-5">
        <h3>Explore Careers</h3>
      </div>
      <div className="container-fluid p-5 career_welcome" >
        <Fade direction="up" delay={200}> <h1>Welcome to Careers at Hamo Tech</h1>
          <p style={{ color: "#8a8a8a", fontSize: "15px" }}>
            At Hamo Tech, we are dedicated to empowering innovation, cultivating
            knowledge, and shaping future leaders in technology. Since our
            establishment, our mission has been to create a dynamic environment
            where talent thrives, ideas flourish, and meaningful impact is made.
            Join us in transforming possibilities into realities.
          </p>
        </Fade>

        <div className="career_text mt-5">
          <Fade direction="up" delay={200}>
            <h3 className="mb-3">Why Work With Us?</h3>
            <h6>Nurturing Growth</h6>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>At Hamo  Tech, we are committed to your professional and personal development. Through mentorship, advanced training, and hands-on projects, we help you reach your full potential and excel in your career.</p>
            <h6>Inclusive Community</h6>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>Diversity is at the heart of our success. As part of a global team, you’ll contribute to an inclusive culture that values diverse perspectives and encourages collaboration to achieve common goals.</p>
            <h6>Balanced Environment</h6>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>We value work-life harmony. With flexible schedules, wellness programs, and supportive initiatives, we ensure that you can succeed both in your career and in your personal life.</p>
            <h6>Global Reach and Impact</h6>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>Hamo Tech is more than an institute—it’s a hub of innovation with a global footprint. Join us to collaborate on projects that make a difference locally and internationally, advancing technology and education for a brighter future.</p>
            <h3 className="mt-5">Current Opportunities</h3>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>Explore exciting opportunities at Hamo Tech. Whether you're looking to contribute to cutting-edge research, lead innovative projects, or inspire the next generation of tech leaders, we have a place for you. Join us in driving technological excellence forward.</p>

            <h3 style={{ color: "#e65753", marginTop: "50px" }}>Trainings & Placements at HAMO Tech</h3>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>At HAMO Tech, we are committed to bridging the gap between education and industry by offering high-quality training and placement assistance. Our comprehensive programs are designed to equip students and professionals with cutting-edge skills in various domains, including MERN Stack Development, Java, DevOps, Python, AI/ML, Data Science, and Cybersecurity. With a strong focus on practical learning, we ensure that our candidates gain hands-on experience to meet the evolving demands of the IT industry.</p>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>Our expert-led training sessions are structured to provide in-depth knowledge and real-world application. We incorporate live projects, coding challenges, and industry case studies to enhance learning outcomes. Whether you are a fresher looking to start your career or a professional seeking to upskill, our tailored programs will help you stay ahead in the competitive job market.</p>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>At HAMO Tech, our commitment goes beyond training – we provide 100% placement assistance to help our trainees secure job opportunities in top IT companies. Our dedicated placement team works closely with industry leaders to connect our candidates with relevant job openings, conduct mock interviews, and offer career guidance. We have successfully placed numerous students in leading tech firms, ensuring their smooth transition from learning to employment.</p>
            <p style={{ color: "#8a8a8a", fontSize: "15px" }}>By joining our training & placement programs, you are not just learning a skill – you are investing in a successful and rewarding career. Take the first step toward your dream job with HAMO Tech and transform your future today!</p>
          </Fade>
        </div>
      </div>

      <div className="container-fluid p-5">
        <section className="container-fluid">
          <div className="row y-gap-50">
            <div className="">
              <div className="row side-content__wrap">
                {careersList.map((course) => (
                  <CourseCard key={course.id} course={course} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>


      <div className="container-fluid career_company_section">
        <h1>Our Trusted Placement Partners</h1>
        <div className="row">
          <div className='col-lg-12  m-auto'>
            <OwlCarousel className="owl-theme mt-5" {...options} style={{ display: "block" }}> {/* Use the OwlCarousel Component */}


              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Tata_Consultancy_Services_Logo.svg/1200px-Tata_Consultancy_Services_Logo.svg.png" alt="tcs" />
              </div>

              <div className="career_compny_list">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8jaBX9jio6DSxCov1xCzOa4XxbU2gaOFhgg&s" alt="accenture" />
              </div>


              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Infosys_logo.svg/2560px-Infosys_logo.svg.png" alt="infosys" />
              </div>

              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Tech_Mahindra_New_Logo.svg/2560px-Tech_Mahindra_New_Logo.svg.png" alt="Techmahindra" />
              </div>

              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Dell_Logo.png" alt="dell" />
              </div>






              <div className="career_compny_list">
                <img src="https://1000logos.net/wp-content/uploads/2021/04/ADP-logo.png" alt="adp" />
              </div>


              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Capgemini_201x_logo.svg/2560px-Capgemini_201x_logo.svg.png" alt="capgemini" />
              </div>

              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/2560px-IBM_logo.svg.png" alt="ibm" />
              </div>

              <div className="career_compny_list">
                <img src="https://cdn.freelogovectors.net/wp-content/uploads/2022/02/mind_tree_logo_freelogovectors.net_.png" alt="mt" />
              </div>


              <div className="career_compny_list">
                <img src="https://1000logos.net/wp-content/uploads/2023/03/HCL-Logo-1976.png" alt="hcl" />
              </div>




              <div className="career_compny_list">
                <img src="https://di-uploads-pod5.dealerinspire.com/triplejsaipan/uploads/2018/05/HyundaiLogoStacked_4cblk-1024x659.gif" alt="adp" />
              </div>


              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Capgemini_201x_logo.svg/2560px-Capgemini_201x_logo.svg.png" alt="capgemini" />
              </div>

              <div className="career_compny_list">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/2560px-IBM_logo.svg.png" alt="ibm" />
              </div>

              <div className="career_compny_list">
                <img src="https://cdn.freelogovectors.net/wp-content/uploads/2022/02/mind_tree_logo_freelogovectors.net_.png" alt="mt" />
              </div>


              <div className="career_compny_list">
                <img src="https://1000logos.net/wp-content/uploads/2023/03/HCL-Logo-1976.png" alt="hcl" />
              </div>
            </OwlCarousel>


          </div>
        </div>
      </div>
    </div>
  );
}

export default Careers;
